import { CustomProvider } from 'firebase/app-check'

import { application } from 'state/application'
import { emitSystemNotification } from 'state/system_notification'

import { ATTESTATION_TOKEN_LOCAL_KEY } from './types'

/**
 * Check if there is an attestation token in the {@link window.localStorage}
 * under the key {@link ATTESTATION_TOKEN_LOCAL_KEY} that hasn't
 * expired, if true, returns this token immediately. Otherwise,
 * makes a request to the backend to get the token and then proceeds
 * to store the token in the {@link window.localStorage} under the key
 * {@link ATTESTATION_TOKEN_LOCAL_KEY}
 *
 * @returns the attestation token, on error emits the event and returns an invalid token
 */
const getToken = async () => {
	const localTokenStr = window.localStorage.getItem(ATTESTATION_TOKEN_LOCAL_KEY)

	// Check if we have a local token stored
	// if true, check if it hasn't expired
	// if all ok, return the attestatin token
	if (localTokenStr) {
		const data = JSON.parse(localTokenStr)

		if (Date.now() < data.expires) {
			return {
				token: data.attestationData.token,
				expireTimeMillis: data.attestationData.tllMillis
			}
		}
	}

	// Failed to get a local unexpired attestation token
	// go to the backend to get a new one
	const { data, error } = await application.peek().forAttestation().getToken()

	if (error) {
		emitSystemNotification({
			display: 'dialog',
			error
		})

		return {
			token: '',
			expireTimeMillis: 1
		}
	}

	const dataToStore = JSON.stringify({
		// Is ok to not consider time zone
		// this logic to store it locally is to
		// avoid multiple request to get the
		// attestation token
		expires: Date.now() + data.ttlMillis,
		attestationData: data
	})

	// Store the attestation data
	// with when it's going to expire
	window.localStorage.setItem(ATTESTATION_TOKEN_LOCAL_KEY, dataToStore)

	return {
		token: data.token,
		expireTimeMillis: data.tllMillis
	}
}

/**
 * {@link CustomProvider} that uses {@link getToken} to return attestation token
 * for firebase app check
 */
export const customCheckProvider = new CustomProvider({
	getToken
})
